import { NotificationEntry, productNames, type Copy } from '@beyond-js/ui/react';
import { useI18n } from '@cdn/i18n';

/**
 * The copy of the shared notification entry and inbox in the selected language: the family's own set
 * (`NotificationEntry.labels`, the same object as `NotificationInbox.labels`, English and Spanish since
 * `@beyond-js/ui` 0.7.2). It is one frozen object per language, so the components are rebuilt only when the
 * language changes.
 */
export function useLabels(): Copy {
	const { locale } = useI18n();
	return NotificationEntry.labels[locale.code === 'es' ? 'es' : 'en'];
}

/**
 * The products whose notices reach this inbox, by the family's names (`productNames` of `@beyond-js/ui`,
 * untranslated): the inbox's product filter offers these and no others, so the Desktop and Docs, which produce
 * no notices, never become filter options.
 */
export const PRODUCTS: Record<string, string> = Object.fromEntries(
	['projects', 'workspace', 'delegate', 'cdn', 'snapshots', 'conduict', 'accounts'].map(id => [id, productNames[id]])
);
